export default "__VITE_ASSET__yerQTHTP__"